import { motion } from "framer-motion";
import { useState } from "react";
import { Car, Heart, Shield, Users, Check } from "lucide-react";
import HeroSlider from "../event_media/HeroSlider";
import Images from "../../utils/Images";

export default function InsuranceChoices() {
  const [selectedOption, setSelectedOption] = useState(1);

  const insuranceOptions = [
    {
      id: 1,
      title: "Road Trip Insurance",
      description: "Simple one-way cover for road travel",
      icon: Car,
      image: "https://cdn-icons-png.flaticon.com/512/3774/3774278.png",
      color: "emerald",
      borderColor: "border-emerald-500",
    },
    {
      id: 2,
      title: "Life Insurance",
      description: "Simple one-way cover for road travel",
      icon: Heart,
      image: "https://cdn-icons-png.flaticon.com/512/1828/1828640.png",
      color: "red",
      borderColor: "border-red-500",
    },
    {
      id: 3,
      title: "Health Insurance",
      description: "Simple one-way cover for road travel",
      icon: Shield,
      image: "https://cdn-icons-png.flaticon.com/512/2966/2966329.png",
      color: "blue",
      borderColor: "border-blue-500",
    },
    {
      id: 4,
      title: "General Insurance",
      description: "Simple one-way cover for road travel",
      icon: Users,
      image: "https://cdn-icons-png.flaticon.com/512/3135/3135715.png",
      color: "purple",
      borderColor: "border-purple-500",
    },
  ];

  const heroImages = [
    Images.hero_img_web_three,
    Images.hero_img_web_four,
  ].filter(Boolean);
  const heroSlides = heroImages.length ? heroImages : [Images.hero_img_web_one];

  return (
    <section className="px-4 py-20 bg-white sm:px-6 lg:px-8">
      <HeroSlider images={heroSlides} />
      <div className="mx-auto max-w-7xl">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 text-center"
        >
          <h2 className="text-3xl font-bold text-gray-900 sm:text-4xl lg:text-5xl">
            Choose Your Insurance
          </h2>
          <div className="mt-4 w-24 h-0.5 bg-emerald-400 mx-auto"></div>
        </motion.div>

        {/* Insurance Options Grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {insuranceOptions.map((option, index) => (
            <motion.div
              key={option.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ y: -8, scale: 1.02 }}
              onClick={() => setSelectedOption(option.id)}
              className={`group relative overflow-hidden rounded-2xl transition-all duration-300 cursor-pointer bg-white shadow-lg ${
                selectedOption === option.id
                  ? `ring-4 ${option.borderColor} shadow-xl`
                  : "ring-1 ring-gray-200 hover:ring-2 hover:ring-gray-300"
              }`}
            >
              {/* Selection Checkmark */}
              {selectedOption === option.id && (
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.2 }}
                  className={`absolute top-3 right-3 z-10 flex h-6 w-6 items-center justify-center rounded-full ${option.borderColor.replace(
                    "border-",
                    "bg-"
                  )} text-white shadow-lg`}
                >
                  <Check size={16} />
                </motion.div>
              )}

              {/* Content */}
              <div className="relative p-6">
                {/* Icon/Image */}
                <div className="flex justify-center mb-4">
                  <div className="overflow-hidden relative w-20 h-20 rounded-xl">
                    <img
                      src={option.image}
                      alt={option.title}
                      className="object-contain w-full h-full transition-transform duration-300 group-hover:scale-110"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="text-center">
                  <h3 className="mb-2 text-lg font-semibold text-gray-900">
                    {option.title}
                  </h3>
                  <p className="text-sm text-gray-600">{option.description}</p>
                </div>

                {/* Hover Effect */}
                <div className="absolute inset-0 rounded-2xl ring-2 ring-transparent transition-all duration-300 group-hover:ring-gray-200" />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Continue Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-16 text-center"
        >
          <button
            className="px-12 py-4 text-lg font-semibold text-white bg-emerald-600 rounded-full shadow-lg transition-all duration-300 hover:bg-emerald-700 hover:scale-105"
            onClick={() => {
              const selected = insuranceOptions.find(
                (opt) => opt.id === selectedOption
              );
              console.log(`Selected: ${selected?.title}`);
              // Add your navigation logic here
            }}
          >
            Continue with{" "}
            {insuranceOptions.find((opt) => opt.id === selectedOption)?.title}
          </button>
        </motion.div>
      </div>
    </section>
  );
}
